export default {
  itemDescriptionDefaultColor: undefined,
  itemDescriptionFontSize: 'sm',
  itemDescriptionFontWeight: undefined,
  itemDescriptionLineHeight: 'sm',
};
